// extracted by mini-css-extract-plugin
export default {"link":"xKBIEi","root":"nKYEcM","label":"lU032T"};